import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Geometry, TYPES, Buffer, utils } from '@pixi/core';
var ParticleBuffer = /*#__PURE__*/function () {
  function ParticleBuffer(properties, dynamicPropertyFlags, size) {
    _classCallCheck(this, ParticleBuffer);
    this.geometry = new Geometry();
    this.indexBuffer = null;
    this.size = size;
    this.dynamicProperties = [];
    this.staticProperties = [];
    for (var i = 0; i < properties.length; ++i) {
      var property = properties[i];
      property = {
        attributeName: property.attributeName,
        size: property.size,
        uploadFunction: property.uploadFunction,
        type: property.type || TYPES.FLOAT,
        offset: property.offset
      };
      if (dynamicPropertyFlags[i]) {
        this.dynamicProperties.push(property);
      } else {
        this.staticProperties.push(property);
      }
    }
    this.staticStride = 0;
    this.staticBuffer = null;
    this.staticData = null;
    this.staticDataUint32 = null;
    this.dynamicStride = 0;
    this.dynamicBuffer = null;
    this.dynamicData = null;
    this.dynamicDataUint32 = null;
    this._updateID = 0;
    this.initBuffers();
  }
  _createClass(ParticleBuffer, [{
    key: "initBuffers",
    value: function initBuffers() {
      var geometry = this.geometry;
      var dynamicOffset = 0;
      this.indexBuffer = new Buffer(utils.createIndicesForQuads(this.size), true, true);
      geometry.addIndex(this.indexBuffer);
      this.dynamicStride = 0;
      for (var i = 0; i < this.dynamicProperties.length; ++i) {
        var property = this.dynamicProperties[i];
        property.offset = dynamicOffset;
        dynamicOffset += property.size;
        this.dynamicStride += property.size;
      }
      var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);
      this.dynamicData = new Float32Array(dynBuffer);
      this.dynamicDataUint32 = new Uint32Array(dynBuffer);
      this.dynamicBuffer = new Buffer(this.dynamicData, false, false);
      var staticOffset = 0;
      this.staticStride = 0;
      for (var _i = 0; _i < this.staticProperties.length; ++_i) {
        var _property = this.staticProperties[_i];
        _property.offset = staticOffset;
        staticOffset += _property.size;
        this.staticStride += _property.size;
      }
      var statBuffer = new ArrayBuffer(this.size * this.staticStride * 4 * 4);
      this.staticData = new Float32Array(statBuffer);
      this.staticDataUint32 = new Uint32Array(statBuffer);
      this.staticBuffer = new Buffer(this.staticData, true, false);
      for (var _i2 = 0; _i2 < this.dynamicProperties.length; ++_i2) {
        var _property2 = this.dynamicProperties[_i2];
        geometry.addAttribute(_property2.attributeName, this.dynamicBuffer, 0, _property2.type === TYPES.UNSIGNED_BYTE, _property2.type, this.dynamicStride * 4, _property2.offset * 4);
      }
      for (var _i3 = 0; _i3 < this.staticProperties.length; ++_i3) {
        var _property3 = this.staticProperties[_i3];
        geometry.addAttribute(_property3.attributeName, this.staticBuffer, 0, _property3.type === TYPES.UNSIGNED_BYTE, _property3.type, this.staticStride * 4, _property3.offset * 4);
      }
    }
  }, {
    key: "uploadDynamic",
    value: function uploadDynamic(children, startIndex, amount) {
      for (var i = 0; i < this.dynamicProperties.length; i++) {
        var property = this.dynamicProperties[i];
        property.uploadFunction(children, startIndex, amount, property.type === TYPES.UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
      }
      this.dynamicBuffer._updateID++;
    }
  }, {
    key: "uploadStatic",
    value: function uploadStatic(children, startIndex, amount) {
      for (var i = 0; i < this.staticProperties.length; i++) {
        var property = this.staticProperties[i];
        property.uploadFunction(children, startIndex, amount, property.type === TYPES.UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
      }
      this.staticBuffer._updateID++;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.indexBuffer = null;
      this.dynamicProperties = null;
      this.dynamicBuffer = null;
      this.dynamicData = null;
      this.dynamicDataUint32 = null;
      this.staticProperties = null;
      this.staticBuffer = null;
      this.staticData = null;
      this.staticDataUint32 = null;
      this.geometry.destroy();
    }
  }]);
  return ParticleBuffer;
}();
export { ParticleBuffer };